import 'publicpath' // imported for side effects

import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'react-hot-loader'

import ReactDOM from 'react-dom'
import { ConnectedRouter } from 'connected-react-router'
import ScrollToTop from 'components/base/scrolltotop'
import { Provider } from 'react-redux'
import mapValues from 'keymap'
import { HotKeys } from 'react-hotkeys'
import LocationModal from 'components/modal/location'
import GlobalShortcuts from 'components/base/globalshortcuts'
import { AppProvider } from '@tracklib/kit'
import Link from 'components/base/link'
import TwitterPixel from 'lib/twitterpixel'

import BingPixel from 'lib/bingpixel'

import version from 'version'
import {
  APP_SERVICE_SENTRY_ENABLED,
  BING_PIXEL_ID,
  CDN_ROOT,
  FB_PIXEL_ID,
  HOSTNAME,
  PIXELS_ENABLED,
  SENTRY_DSN,
  TONE_SILENCE_LOGGING,
  TRACKING_ENABLED,
  TWITTER_PIXEL_ID,
} from '@constants'
import App from 'view'
import { loadableReady } from '@loadable/component'

import { store, history } from 'store'
import { actions as authActions } from 'modules/auth/actions'
import { actions as signupActions } from 'modules/signup/actions'

if (TONE_SILENCE_LOGGING) {
  window.TONE_SILENCE_LOGGING = true
}

store.dispatch(authActions.authCheck())
store.dispatch(signupActions.storeRefCodeInCookie())

if (TRACKING_ENABLED) {
  import(
    /* webpackChunkName: 'tracking' */
    'react-facebook-pixel'
  ).then(({ default: ReactPixel }) => {
    if (PIXELS_ENABLED) {
      ReactPixel.init(FB_PIXEL_ID, {}, { autoConfig: false, debug: false })
      ReactPixel.pageView()
      TwitterPixel.init(TWITTER_PIXEL_ID)
      BingPixel.init(BING_PIXEL_ID)
      BingPixel.pageView()
    }
    history.listen(location => {
      ga('set', 'anonymizeIp', true)
      ga('set', 'page', location.pathname + location.search)
      ga('send', 'pageview')
      gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
      })
      if (PIXELS_ENABLED) {
        ReactPixel.pageView()
        BingPixel.pageView()
      }
    })
  })
}

if (APP_SERVICE_SENTRY_ENABLED) {
  import(
    /* webpackChunkName: 'tracking' */
    '@sentry/browser'
  ).then(Sentry => {
    Sentry.init({
      dsn: SENTRY_DSN,
      release: version.tag,
      commit: version.commit,
      environment: process.env.NODE_ENV,
      ignoreErrors: ['AbortError', 'NotSupportedError'],
    })
  })
}

const renderFunc = (app, el) => (module.hot ? ReactDOM.render(app, el) : loadableReady(() => ReactDOM.hydrate(app, el)))

const render = () => {
  renderFunc(
    <AppProvider constants={{ HOSTNAME, CDN_ROOT }} linkComponent={Link}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <HotKeys keyMap={mapValues}>
            <ScrollToTop>
              <App store={store} history={history} />
            </ScrollToTop>
            <LocationModal />
            <GlobalShortcuts />
          </HotKeys>
        </ConnectedRouter>
      </Provider>
    </AppProvider>,
    document.getElementById('app'),
  )
}

if (module.hot) {
  module.hot.accept()
}

render()
